<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">骑行订单信息</span>
      </div>
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small">
        <el-form-item label="品牌名称">
          <el-select v-model="form.brandId" style="width: 120px">
            <el-option label="全部" value="all"></el-option>
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in brands"
              :key="item.key"/>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model.trim="form.orderNo" clearable style="width: 250px"/>
        </el-form-item>
        <el-form-item label="车辆编号">
          <el-input v-model.trim="form.bikeId" clearable style="width: 150px"/>
        </el-form-item>
        <el-form-item label="车辆类型：">
          <el-select style="width: 100px;" v-model="form.bikeType" placeholder="" :disabled="form.disabled">
            <el-option :label="item.label" :value="item.value" v-for="item in bikeTypeList" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.timeType" placeholder="请选择时间类型" style="width: 100px;" class="custom-select">
            <el-option label="租车时间" value="1"></el-option>
            <el-option label="还车时间" value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="form.dataRange"
            style="width: 240px"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="form.payStatus"  style="width: 100px">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in payStatusOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button v-show="checkUserAuth(4, 239)" @click="onExportBtn">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 10.3125rem"></div>
    <div class="pagination-bg-white layout-header">
      <el-table
        v-show="checkUserAuth(4, 236)"
        v-loading.body="tableLoading"
        :data="tableData"
        :height="tableViewHeight"
        width="100%"
        @sort-change="handleSortChange"
        highlight-current-row>
        <el-table-column prop="index" label="序号" align="center" width="60">
          <template v-slot="props">
            <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brandId" label="品牌名称" align="center">
          <template v-slot="{row}">
            {{ row.brandId | filterBrandName(brands) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户编号" align="center"></el-table-column>
        <el-table-column prop="bikeId" label="车辆编号" align="center"></el-table-column>
        <el-table-column prop="bikeType" label="车辆类型" align="center">
          <template v-slot="props">
            <span>{{props.row.bikeType | filterBikeType}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalFee" label="订单总金额" align="center">
          <template v-slot="props">
            <span>{{props.row.totalFee}} 元</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="租车时间" sortable width="180">
          <template v-slot="props">
            <span>{{props.row.startTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="还车时间" sortable width="180">
          <template v-slot="props">
            <span>{{props.row.endTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="骑行时长" align="center">
          <template v-slot="props">
            <span>{{ formatDuration(props.row.duration) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="distance" label="骑行里程" align="center">
          <template v-slot="props">
            <span>{{props.row.distance}} 公里</span>
          </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="支付状态" align="center">
          <template v-slot="props">
            <span>{{props.row.payStatus | filterPayStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="头盔佩戴状态" align="center">
          <template v-slot="props">
            <span>{{props.row.helmetUsageStatus | filterHelmetUsageStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="props">
            <span @click="getOrderDetail(props.row)" class="table-btn blue cursor">详情</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="pageNoChange"
        :current-page="formData.pageNum"
        :page-sizes="pageSizes"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <div v-show="!checkUserAuth(4, 236)">您的账户没有权限查看此内容！</div>
    </div>
    <el-dialog title="骑行订单明细" :visible.sync="dialogVisible"
               :modal="false"
               :close-on-click-modal="false"
               width="35%">
      <div class="info-line">
        <span class="label">品牌名称：</span>
        <span class="value">{{ detail.brandId | filterBrandName(brands) }}</span>
      </div>
      <div class="info-line">
        <span class="label">订单号：</span>
        <span class="value">{{ detail.orderNo }}</span>
      </div>
      <div class="info-line">
        <span class="label">车辆编号：</span>
        <span class="value">{{ detail.bikeId }}</span>
      </div>
      <div class="info-line">
        <span class="label">支付状态：</span>
        <span class="value" style="color: #1ca0ff">{{ detail.payStatus | filterPayStatus }}</span>
      </div>
      <!--已支付订单相关费用-->
      <div v-if="detail.payStatus==1||detail.payStatus==2">
        <div class="info-line">
          <span class="label">实际支付金额：</span>
          <span class="value">{{ detail.payData.payAmount }}元</span>
        </div>
        <div class="info-line">
          <el-tooltip class="item" effect="dark" content="包含优惠券及红包等" placement="top">
            <span class="label hover-dark" style="cursor: default;">优惠金额：</span>
          </el-tooltip>
          <span class="value">{{ detail.payData.totalDiscountAmount }}元</span>
        </div>
        <div class="info-line">
          <el-tooltip class="item" effect="dark" content="包含管理费及调度费" placement="top">
            <span class="label hover-dark" style="cursor: default;">扣费金额：</span>
          </el-tooltip>
          <span class="value">{{ detail.payData.totalDeductedAmount }}元</span>
        </div>
        <div class="info-line">
          <span class="label">支付时间：</span>
          <span class="value">{{ detail.payData.payTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
        </div>
      </div>
      <!--已退费订单相关费用-->
      <div v-if="detail.payStatus==2">
        <div class="info-line">
          <span class="label">退款编号：</span>
          <span class="value">{{ detail.payData.refundNo }}</span>
        </div>
        <div class="info-line">
          <span class="label">退款金额：</span>
          <span class="value">{{ detail.payData.refundAmount }}元</span>
        </div>
        <div class="info-line">
          <span class="label">退款时间：</span>
          <span class="value">{{ detail.payData.refundTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
        </div>
      </div>
      <div class="info-line">
        <span class="label">租车时间：</span>
        <span class="value">{{ detail.startTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
      </div>
      <div class="info-line">
        <span class="label">还车时间：</span>
        <span class="value">{{ detail.endTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
      </div>
      <div class="info-line">
        <span class="label">起点位置：</span>
        <span class="value">{{ detail.startAddress }}</span>
      </div>
      <div class="info-line">
        <span class="label">终点位置：</span>
        <span class="value">{{ detail.endAddress }}</span>
      </div>
      <div class="info-line">
        <span class="label">行程轨迹：</span>
        <span class="value" @click="getOrderTrack(detail.orderNo)" style="color: #1ca0ff;cursor: pointer;">点击查看用户行程轨迹</span>
      </div>
    </el-dialog>
    <el-dialog title="查看用户行程轨迹" :visible.sync="dialogOrderTrackVisible"
               :modal="false"
               :close-on-click-modal="false"
               width="50%">
      <div id="orderTrackMap" ref="orderTrackMap" style="height: 500px;position: relative"></div>
      <el-card shadow="always" class="track_card">
        <div class="card-line">
          <span class="label">骑行时长：</span>
          <span class="value">{{ formatDuration(detail.duration) }}</span>
        </div>
        <div class="card-line">
          <span class="label">骑行里程：</span>
          <span class="value">{{ detail.distance }}公里</span>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import { lookPDF } from '@/utils/tools'
import startImg from '@/assets/clock/start.png'
import endImg from '@/assets/clock/end.png'
var AMap = window.AMap
export default {
  name: 'bikeRideOrder',
  data() {
    return {
      form: {
        brandId: 'all',
        payStatus: 'all',
        orderNo: '',
        bikeId: '',
        timeType: '1',
        dataRange: [this.dayjs(new Date()).format('YYYY-MM-DD'),
          this.dayjs(new Date()).format('YYYY-MM-DD')],
        bikeType: '',
        disabled: true
      },
      payStatusOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: 0,
          label: '未支付'
        }, {
          key: 1,
          label: '已支付'
        }, {
          key: 2,
          label: '已退款'
        }],
      tableViewHeight: 50,
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      total: 0,
      pageSizes: [10, 20, 50],
      orderBy: 'start_time asc',
      dialogVisible: false,
      detail: {},
      dialogOrderTrackVisible: false,
      orderTrackMap: null,
      bikeTypeList: [
        { value: '', label: '全部' },
        { value: 0, label: '自行车' },
        { value: 1, label: '电动车' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'selfAreaId',
      'brands',
      'userBikeType'])
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    },
    filterPayStatus(value) {
      return {
        0: '未支付',
        1: '已支付',
        2: '已退款'
      }[Number(value)]
    },
    filterHelmetUsageStatus(value) {
      let strName = '未知'
      if (value === 0) {
        strName = '未佩戴'
      } else if (value === 1) {
        strName = '已佩戴'
      } else {
        strName = '未知'
      }
      return strName
    },
    filterBikeType(value) {
      return {
        0: '自行车',
        1: '电动车'
      }[Number(value)]
    }
  },
  created() {
    this.resetUserBikeType()
    this.onSearch()
  },
  methods: {
    onSearch() {
      this.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        orderNo: this.form.orderNo,
        bikeId: this.form.bikeId,
        timeType: this.form.timeType,
        orderBy: this.orderBy,
        userBikeType: this.form.bikeType
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.payStatus !== 'all') {
        params.payStatus = this.form.payStatus
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.getBikeRideOrderList(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    handleSortChange({ column, prop, order }) {
      if (order === 'ascending') {
        if (prop === 'startTime') {
          this.orderBy = 'start_time asc'
        } else {
          this.orderBy = 'end_time asc'
        }
      } else {
        if (prop === 'startTime') {
          this.orderBy = 'start_time desc'
        } else {
          this.orderBy = 'end_time desc'
        }
      }
      this.onSearch()
    },
    onReset() {
      this.form.brandId = 'all'
      this.form.payStatus = 'all'
      this.form.orderNo = ''
      this.form.bikeId = ''
      this.form.timeType = '1'
      this.form.dataRange = [this.dayjs(new Date()).format('YYYY-MM-DD'),
        this.dayjs(new Date()).format('YYYY-MM-DD')]
      this.resetUserBikeType()
      this.onSearch()
    },
    formatDuration(seconds) {
      if (seconds == null || isNaN(seconds)) return '0秒'
      const sec = parseInt(seconds)
      if (sec <= 0) return '0秒'
      // 计算各个时间单位
      const hours = Math.floor(sec / 3600)
      const minutes = Math.floor((sec % 3600) / 60)
      const remainingSeconds = sec % 60
      // 拼接时间字符串
      const parts = []
      if (hours > 0) parts.push(`${hours}小时`)
      if (minutes > 0) parts.push(`${minutes}分钟`)
      if (remainingSeconds > 0) parts.push(`${remainingSeconds}秒`)
      // 处理全零的特殊情况
      if (parts.length === 0) return '0秒'
      return parts.join('')
    },
    getOrderDetail(row) {
      const params = {
        selfAreaId: this.selfAreaId,
        orderNo: row.orderNo
      }
      Api.getBikeRideOrderDetail(params).then((res) => {
        if (res.code === 200) {
          this.dialogVisible = true
          const payData = res.data.detail
          this.detail = {
            ...row,
            payData
          }
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    getOrderTrack(orderNo) {
      this.dialogOrderTrackVisible = true
      this.$nextTick(() => {
        const container = this.$refs.orderTrackMap
        // 获取到作为地图容器的DOM元素，创建地图实例
        if (container) {
          this.clockTrackMap = new AMap.Map('orderTrackMap', {
            resizeEnable: true,
            zoom: 16 // 初始化地图级别
          })
        }
        const params = {
          selfAreaId: this.selfAreaId,
          orderNo: orderNo
        }
        Api.getBikeRideOrderTrack(params).then((res) => {
          if (res.code === 200) {
            if (res.data.track) {
              const trackData = res.data.track
              this.getOrderUserTrack(trackData)
            } else {
              this.$message.warning('暂无用户行程轨迹信息')
            }
          } else {
            this.$message.warning(res.message)
          }
        })
      })
    },
    getOrderUserTrack(trackData) {
      const trackPoints = JSON.parse(trackData.tracks)
      const lineArr = []
      trackPoints.forEach(item => {
        lineArr.push([item.lon, item.lat])
      })
      this.clockTrackMap = new AMap.Map('orderTrackMap', { // 设置地图容器id
        resizeEnable: true,
        viewMode: '2D', // 使用2D视图
        zoomEnable: true, // 地图是否可缩放，默认值为true
        dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
        zoom: 12, // 初始化地图级别
        center: lineArr[0], // 初始化中心点坐标 北京
        showLabel: true,
        expandZoomRange: false,
        showIndoorMap: false
      })
      // 创建图标对象
      const startIcon = new AMap.Icon({
        image: startImg, // 使用导入的图片
        size: new AMap.Size(20, 34),
        imageSize: new AMap.Size(20, 34)
      })
      const endIcon = new AMap.Icon({
        image: endImg, // 使用导入的图片
        size: new AMap.Size(20, 34),
        imageSize: new AMap.Size(20, 34)
      })
      const markers = []
      // 创建起点标记点
      const startMarker = new AMap.Marker({
        position: lineArr[0],
        icon: startIcon,
        offset: new AMap.Pixel(-10, -34),
        map: this.clockTrackMap // 将标记添加到地图上
      })
      markers.push(startMarker)
      // 创建终点标记点
      const endMarker = new AMap.Marker({
        position: lineArr[lineArr.length - 1],
        icon: endIcon,
        offset: new AMap.Pixel(-10, -34),
        map: this.clockTrackMap // 将标记添加到地图上
      })
      markers.push(endMarker)
      // 绘制轨迹
      const polyline = new AMap.Polyline({
        path: lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        strokeWeight: 6, // 线宽
        strokeStyle: 'solid' // 线样式
      })
      this.clockTrackMap.add(polyline)
    },
    onExportBtn() {
      if (this.total > 0) {
        this.onSureExport()
      } else {
        this.$message({
          message: '导出数据为空，请核查！',
          type: 'warning'
        })
      }
    },
    onSureExport() {
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        orderNo: this.form.orderNo,
        bikeId: this.form.bikeId,
        timeType: this.form.timeType,
        orderBy: this.orderBy,
        userBikeType: this.form.bikeType
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.payStatus !== 'all') {
        params.payStatus = this.form.payStatus
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.exportBikeRideOrder(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    resetUserBikeType() {
      if (this.userBikeType === 2) {
        this.form.bikeType = ''
        this.form.disabled = false
      } else {
        this.form.bikeType = this.userBikeType
        this.form.disabled = true
      }
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 170
      })
    }
  }
}
</script>

<style lang="less" scoped>
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}
.demo-form-inline{
  margin-top: 24px;
}
::v-deep .el-table::before {
  left: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 0.0625rem !important;
}
::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  content: '' !important;
  position: absolute !important;
  background-color: #EBEEF5 !important;
  z-index: 1 !important;
}
::v-deep .custom-select .el-input__inner{
  border: none !important;
}
.info-line {
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 15px; /* 每行之间的间距 */
  .label {
    min-width: 120px; /* 根据需要设置标签的最小宽度 */
    text-align: right; /* 标签文本右对齐（但冒号会保持在左边，因为冒号是标签的一部分） */
    padding-right: 15px; /* 标签和值之间的间距 */
    box-sizing: border-box; /* 确保padding不会增加元素的总宽度 */
  }
  /* 添加悬浮加深效果 */
  .hover-dark:hover {
    color: #000000 !important; /* 使用深灰色，根据需要调整颜色值 */
    transition: color 0.3s; /* 添加平滑过渡效果 */
  }
  .value {
    flex-grow: 1; /* 值占据剩余的空间 */
    word-break: break-all; /* 确保长文本不会溢出容器 */
  }
}
::v-deep .el-dialog__body {
  padding: 0px 20px 30px 20px !important;
}
::v-deep .el-card__body, .el-main {
  padding: 10px 10px 0px 10px !important;
}
.track_card {
  position: absolute;
  bottom: 30px;
  right: 20px;
  z-index: 1000; /* 确保卡片在地图上方 */
  max-width: 300px;
  .card-line {
    align-items: center; /* 垂直居中 */
    margin-bottom: 15px; /* 每行之间的间距 */
    .label {
      min-width: 120px; /* 根据需要设置标签的最小宽度 */
      text-align: right; /* 标签文本右对齐（但冒号会保持在左边，因为冒号是标签的一部分） */
      box-sizing: border-box; /* 确保padding不会增加元素的总宽度 */
    }
    .value {
      flex-grow: 1; /* 值占据剩余的空间 */
      word-break: break-all; /* 确保长文本不会溢出容器 */
    }
  }
}
</style>
